export default [
  {
    path: 'tienda-online',
    component: () => import('@/views/empresa/integraciones/IntegracionesLayout.vue'),
    children: [
      {
        path: '',
        name: 'empresa.tiendaOnline',
        component: () => import('@/views/empresa/integraciones/TiendaOnline.vue'),
      }
    ]
  },
  {
    path: 'integraciones',
    name: 'empresa.integraciones',
    redirect: { name: 'empresa.integraciones.list' },
    component: () => import('@/views/empresa/integraciones/IntegracionesLayout.vue'),
    children: [
      {
        path: '',
        name: 'empresa.integraciones.list',
        component: () => import('@/views/empresa/integraciones/IntegracionesList.vue'),
      }
    ]
  },
  // El detalle de una integración es una sola página; las rutas por sección
  // (las usan otras pantallas, como Tienda online) abren la misma página y
  // la llevan a esa sección.
  {
    path: 'integraciones/:uuid_integracion',
    name: 'empresa.integracion.home',
    component: () => import('@/views/empresa/integraciones/IntegracionHome.vue'),
  },
  {
    path: 'integraciones/:uuid_integracion/sucursales',
    name: 'empresa.integracion.sucursales',
    component: () => import('@/views/empresa/integraciones/IntegracionHome.vue'),
    meta: { seccion: 'sucursales' },
  },
  {
    path: 'integraciones/:uuid_integracion/categorias',
    name: 'empresa.integracion.categorias',
    component: () => import('@/views/empresa/integraciones/IntegracionHome.vue'),
    meta: { seccion: 'catalogo' },
  },
  {
    path: 'integraciones/:uuid_integracion/productos',
    name: 'empresa.integracion.productos',
    component: () => import('@/views/empresa/integraciones/IntegracionHome.vue'),
    meta: { seccion: 'catalogo' },
  },
]
